import 'setimmediate'

import { Platform } from 'react-native'

import { env } from '@env'
import { QueryClient } from '@tanstack/react-query'
import { initAnalytics } from '@zet/analytics'
import { LinkBroken } from '@zet/common/components/linkBroken'
import useAuthStore from '@zet/feature-user/store/authStore'
import '@zet/network'
import { initHash } from '@zet/utils/loginHash'
import { useFonts } from 'expo-font'
import { StatusBar } from 'expo-status-bar'
import 'react-native-gesture-handler'
import { enableExperimentalWebImplementation } from 'react-native-gesture-handler'

import Root from './navigation/Root'
import { AppProviders } from './providers/AppProviders'

enableExperimentalWebImplementation(true)

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // cacheTime: 1000 * 60 * 60 * 24 * 7,
      // staleTime: 1000 * 60 * 60 * 24 * 7,
    },
  },
})
initAnalytics(env)

// if (checkIsMagnetFlow()) {
//   setNativewindColors({
//     '--color-primary-250': '#1F003E',
//     '--color-primary-200': '#40037D',
//     '--color-primary-150': '#5D05B5',
//     '--color-primary-120': '#7706E8',
//     '--color-primary-100': '#8307FF',
//     '--color-primary-50': '#F3E6FF',
//     '--color-primary-10': '#F3E6FF',
//     '--color-primary-0': '#F9F2FF',
//   })
// }

function App() {
  const unauthorizedApiError = useAuthStore(
    (state) => state.unauthorizedApiError,
  )

  const [fontsLoaded] = useFonts({
    'Graphie-Bold': require('../assets/fonts/Graphie/Graphie-Bold.otf'),
    'Graphie-Book': require('../assets/fonts/Graphie/Graphie-Book.otf'),
    'Graphie-ExtraBold': require('../assets/fonts/Graphie/Graphie-ExtraBold.otf'),
    'Graphie-Regular': require('../assets/fonts/Graphie/Graphie-Regular.otf'),
    'Graphie-SemiBold': require('../assets/fonts/Graphie/Graphie-SemiBold.otf'),
    'JioType-Black': require('../assets/fonts/JioType/JioType-Black.otf'),
    'JioType-Bold': require('../assets/fonts/JioType/JioType-Bold.otf'),
    'JioType-Light': require('../assets/fonts/JioType/JioType-Light.otf'),
    'JioType-Medium': require('../assets/fonts/JioType/JioType-Medium.otf'),
    JioType: require('../assets/fonts/JioType/JioType.otf'),
    'THICCCBOI-Black': require('../assets/fonts/Thicccboi/THICCCBOI-Black.ttf'),
    'THICCCBOI-Bold': require('../assets/fonts/Thicccboi/THICCCBOI-Bold.ttf'),
    'THICCCBOI-ExtraBold': require('../assets/fonts/Thicccboi/THICCCBOI-ExtraBold.ttf'),
    'THICCCBOI-Light': require('../assets/fonts/Thicccboi/THICCCBOI-Light.ttf'),
    'THICCCBOI-Medium': require('../assets/fonts/Thicccboi/THICCCBOI-Medium.ttf'),
    'THICCCBOI-Regular': require('../assets/fonts/Thicccboi/THICCCBOI-Regular.ttf'),
    'THICCCBOI-SemiBold': require('../assets/fonts/Thicccboi/THICCCBOI-SemiBold.ttf'),
  })

  if (Platform.OS === 'web') {
    ;(window as any)._frameTimestamp = null
  }

  const hash = initHash()

  if (!hash) {
    return <LinkBroken />
  }
  if (unauthorizedApiError) {
    return <LinkBroken />
  }

  if (!fontsLoaded) {
    return null
  }

  return (
    <AppProviders queryClient={client}>
      <Root />
      <StatusBar />
    </AppProviders>
  )
}

export default App
